/*!
 * Local Project Js File
 *
 */

window.requestAnimFrame = (function(){
  return  window.requestAnimationFrame       ||
          window.webkitRequestAnimationFrame ||
          window.mozRequestAnimationFrame    ||
          window.oRequestAnimationFrame      ||
          window.msRequestAnimationFrame     ||
          function( callback ){
            window.setTimeout(callback, 1000 / 60);
          };
})();

(function () {

  "use strict";

  var myApp = {

  }

  myApp.initRematesCalendar = function() {
    var calendarEl = document.getElementById('remates-calendar');

    if (!calendarEl) {
      return;
    }

    var monthLabel = calendarEl.querySelector('.home-remates-calendar-month');
    var daysContainer = calendarEl.querySelector('.home-remates-calendar-days');
    var prevBtn = calendarEl.querySelector('.home-remates-calendar-nav--prev');
    var nextBtn = calendarEl.querySelector('.home-remates-calendar-nav--next');
    var monthNames = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    var eventDates = [];
    var eventsByDate = {};
    var rematePathTemplate = calendarEl.getAttribute('data-remate-path') || '';
    var currentDate = new Date();
    var today = new Date();

    try {
      var remates = JSON.parse(calendarEl.getAttribute('data-remates') || '[]');
      remates.forEach(function(remate) {
        var dateSource = remate.fecha_inicio || remate.fecha;

        if (!dateSource || !remate.id) {
          return;
        }

        var date = dateSource.slice(0, 10);
        eventDates.push(date);

        if (!eventsByDate[date]) {
          eventsByDate[date] = rematePathTemplate.replace('__ID__', remate.id);
        }
      });
    } catch (error) {
      eventDates = [];
      eventsByDate = {};
    }

    if (eventDates.length) {
      var firstEvent = eventDates[0].split('-');
      currentDate = new Date(parseInt(firstEvent[0], 10), parseInt(firstEvent[1], 10) - 1, 1);
    }

    function getEventUrl(year, month, day) {
      var monthString = ('0' + (month + 1)).slice(-2);
      var dayString = ('0' + day).slice(-2);
      var target = year + '-' + monthString + '-' + dayString;

      return eventsByDate[target] || null;
    }

    function renderCalendar() {
      var year = currentDate.getFullYear();
      var month = currentDate.getMonth();
      var firstWeekDay = new Date(year, month, 1).getDay();
      var offset = firstWeekDay === 0 ? 6 : firstWeekDay - 1;
      var daysInMonth = new Date(year, month + 1, 0).getDate();
      var html = '';
      var day;

      monthLabel.textContent = monthNames[month] + ' ' + year;
      daysContainer.innerHTML = '';

      for (day = 0; day < offset; day += 1) {
        html += '<span class="home-remates-calendar-day home-remates-calendar-day--empty"></span>';
      }

      for (day = 1; day <= daysInMonth; day += 1) {
        var dayClass = 'home-remates-calendar-day';
        var eventUrl = getEventUrl(year, month, day);
        var isToday = year === today.getFullYear()
          && month === today.getMonth()
          && day === today.getDate();

        if (isToday) {
          dayClass += ' home-remates-calendar-day--today';
        }

        if (eventUrl) {
          dayClass += ' home-remates-calendar-day--event';
          html += '<a href="' + eventUrl + '" class="' + dayClass + '" title="Ver remate">' + day + '</a>';
        } else {
          html += '<span class="' + dayClass + '">' + day + '</span>';
        }
      }

      daysContainer.innerHTML = html;
    }

    prevBtn.addEventListener('click', function() {
      currentDate.setMonth(currentDate.getMonth() - 1);
      renderCalendar();
    });

    nextBtn.addEventListener('click', function() {
      currentDate.setMonth(currentDate.getMonth() + 1);
      renderCalendar();
    });

    renderCalendar();
  };

  myApp.initNoticiasSlider = function() {
    var $slider = $('.home-noticias-slider');

    if (!$slider.length || $slider.hasClass('slick-initialized')) {
      return;
    }

    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      infinite: false,
      arrows: true,
      dots: false,
      prevArrow: '<button type="button" class="slick-arrow home-noticias-slider-arrow home-noticias-slider-arrow--prev" aria-label="Anterior"><i class="ph ph-caret-left" aria-hidden="true"></i></button>',
      nextArrow: '<button type="button" class="slick-arrow home-noticias-slider-arrow home-noticias-slider-arrow--next" aria-label="Siguiente"><i class="ph ph-caret-right" aria-hidden="true"></i></button>',
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  };

  myApp.init = function() {

    var headerFixed = $('.navbar-fixed-top');

    ruralApp.Flexslider.initFlex('.flexslider',{animation: 'fade'});
    ruralApp.MagnificPopup.initMagnific('.gallery', {delegate: 'a', type: 'image', gallery: { enabled:true }});

    myApp.initRematesCalendar();
    myApp.initNoticiasSlider();


    if (location.pathname == "/app_dev.php/mercados" || location.pathname == "/mercados") {
      var smoothScrollItem = $('.navbar-nav').find('.smooth-scroll');
      smoothScrollItem.off('click', smoothScroll,false);
      smoothScrollItem.on('click', function(event) {
        event.preventDefault();
        window.location = '/' + this.hash;
      });
    } else {
      $('body').scrollspy({ target: '#main-nav', offset: headerFixed.outerHeight(true) });
    }

    $('.gallery-item>a').magnificPopup({
      type: 'image',
      gallery: {
        enabled: true
      }
    });
  }




  document.addEventListener('DOMContentLoaded', function() {
    myApp.init();
  }, false);


})();
